export var AnalyticsEventTypes;
(function (AnalyticsEventTypes) {
    AnalyticsEventTypes["blade_impression"] = "blade_impression";
    AnalyticsEventTypes["email_subscribe_start"] = "email_subscribe_start";
    AnalyticsEventTypes["email_subscribe_success"] = "email_subscribe_success";
    AnalyticsEventTypes["email_subscribe_error"] = "email_subscribe_error";
    AnalyticsEventTypes["content_impression"] = "content_impression";
    AnalyticsEventTypes["content_engagement"] = "content_engagement";
    AnalyticsEventTypes["modal_opened"] = "modal_opened";
    AnalyticsEventTypes["ui_interaction"] = "ui_interaction";
})(AnalyticsEventTypes || (AnalyticsEventTypes = {}));
export const MINIMUM_IMPRESSION_TIME = 500;
export const MINIMUM_THRESHOLD = 0.5;
export function sendEvent(eventName, eventParameters) {
    if (!eventParameters.page && !eventParameters.blade && !eventParameters.uiLocation) {
        console.warn("Empty analytics data provided to sendEvent method.");
        return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
        ...eventParameters,
    });
}
export function generateLinkAnalytics({ title = "unknown", action }, uiType = "Link") {
    return {
        id: title,
        title,
        uiType,
        action,
    };
}
export function generateContentAnalytics(content, uiType) {
    const mediaUrl = "media" in content && content.media?.type === "image" ? content.media.url : "";
    return {
        id: content.analytics?.contentId || content.title || "unknown",
        version: content.analytics?.version,
        rev: content.analytics?.rev,
        locale: content.analytics?.contentLocale || "en-us",
        title: content.title,
        publishDate: content.publishedAt || content.analytics?.publishDate,
        uiType,
        category: content.analytics?.contentCategory,
        imageUrl: mediaUrl,
        action: content.action,
    };
}
export function generateGenericAnalytics(content, uiType) {
    return {
        id: content.title || "unknown",
        title: content.title,
        uiType,
        imageUrl: "media" in content && content.media?.type === "image" ? content.media.url : "",
    };
}
//# sourceMappingURL=analyticsUtils.js.map